import {
    STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED,
    STUDENT_CERTIFICATES_GEM_COUNT_SELECTED
} from './student-certificates-gem-count-actions';

const initialState = {
    retrievedGems: [],
    selectedGems: null
};


/**
 * Student Certificates Gem Count Reducer
 *
 * Consumes STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - contains list of individual student certificates for a class
 *                     as well as total for class
 */
export default function (state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
    case STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED: {
        const { retrievedGems } = action.payload;
        return { ...state, retrievedGems };
    }
    case STUDENT_CERTIFICATES_GEM_COUNT_SELECTED: {
        const { selectedGems } = action.payload;
        return { ...state, selectedGems };
    }
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/certificates/student-certificates-gem-count-reducer.js